<template functional>
  <svg
    style="position: absolute; width: 0; height: 0; overflow: hidden;"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <symbol id="icon-users" viewBox="0 0 18 20">
        <title>users</title>
        <path
          d="M4.6 1c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8S5.5 1 4.6 1zM9 1c-1 0-1.8.8-1.8 1.8S8 4.6 9 4.6s1.8-.8 1.8-1.8S10 1 9 1zm4.4 0c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8S14.4 1 13.4 1zM2.8 5.4c-1 0-1.8.8-1.8 1.8v6.2h.9v5.3h1.8v-7.1h-.9V7.2h1c.1-.6.4-1.2.8-1.8H2.8zm5.3 0c-1.5 0-2.7 1.2-2.7 2.7v7.1h.9v3.6h1.8v-3.6h1.8v3.6h1.8v-3.6h.9V8.1c0-1.5-1.2-2.7-2.7-2.7H8.1zm5.3 0c.4.5.7 1.1.8 1.8h1v4.4h-.9v7.1h1.8v-5.3h.9V7.2c0-1-.8-1.8-1.8-1.8h-1.8zM8.1 7.2h1.8c.5 0 .9.4.9.9v5.3H7.2V8.1c0-.5.4-.9.9-.9z"
        />
      </symbol>
      <symbol id="icon-device" viewBox="0 0 25 17">
        <title>device</title>
        <path
          d="M12.5 1c-2.2 0-4.5.3-6.4.8S2.6 2.9 1.5 3.9c-.3.4-.5.9-.5 1.4v2.5c0 2 .5 3.9 1.6 5.5s2.8 2.7 5 2.7h.2c1.7 0 2.8-1.2 3.4-2 .3-.4.6-.8.8-1 .2-.2.3-.2.5-.2s.3 0 .5.2.5.5.8 1c.6.8 1.7 2 3.4 2h.2c2.1 0 3.9-1.1 5-2.7S24 9.8 24 7.8V5.3c0-.5-.2-1-.5-1.3-1-1-2.6-1.6-4.6-2.1S14.7 1 12.5 1zm0 2.1c2 0 4.1.3 5.9.7 1.7.4 3.1 1.1 3.5 1.5v2.4c0 1.6-.4 3.1-1.2 4.3-.8 1.1-1.8 1.8-3.3 1.8h-.2c-.9 0-1.2-.4-1.8-1.2-.3-.4-.6-.8-1-1.3-.5-.4-1.1-.8-1.9-.8-.8 0-1.4.4-1.9.8s-.8.9-1.1 1.2c-.6.8-.9 1.2-1.8 1.2h-.2C6 13.7 5 13 4.2 11.9S3.1 9.4 3.1 7.8V5.4c.4-.4 1.8-1.1 3.5-1.5 1.8-.5 3.9-.8 5.9-.8z"
        />
      </symbol>
      <symbol id="icon-tags" viewBox="0 0 23 18">
        <title>tags</title>
        <path
          d="M14.8 1L6.6 9.2c-.4.4-.6.9-.6 1.5s.2 1.1.6 1.5l4.2 4.2c.4.4.9.6 1.5.6s1.1-.2 1.5-.6L22 8.2V1h-7.2zm-5.4.3L1.6 9.1c-.4.3-.6.8-.6 1.4s.2 1 .6 1.4L7 17.3l1.4-1.4L3 10.5l7.8-7.8-1.4-1.4zM15.6 3H20v4.4L12.4 15h-.2L8 10.7v-.1L15.6 3zM17 5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
        />
      </symbol>
      <symbol id="icon-upload-2" viewBox="0 0 58 58">
        <title>upload-2</title>
        <path
          d="M29 2L12.8 18.2h10.8v21.6c0 1.5 1.2 2.7 2.7 2.7h5.4c1.5 0 2.7-1.2 2.7-2.7V18.2h10.8L29 2zM2 50.6V56h54v-5.4H2z"
        />
      </symbol>
    </defs>
  </svg>
</template>

<script>
export default {
  functional: true,
};
</script>
